// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"de73a413","122":"36250f7c","294":"d4e05fc8","432":"93525057","601":"a1cc88a2","640":"f2aedc28","753":"dee3b5e3","892":"43be7801","916":"b871a277","954":"7f2bf5ed"}[chunkId] + ".js";
};